import React from 'react';

interface GridAlphabetIconProps {
  icon: string;
  size?: number;
  className?: string;
  color?: string;
}

const GridAlphabetIcon: React.FC<GridAlphabetIconProps> = ({ 
  icon, 
  size = 24, 
  className = '',
  color = 'currentColor'
}) => {
  const iconProps = {
    width: size,
    height: size,
    className: `grid-alphabet-icon ${className}`,
    fill: color,
    viewBox: '0 0 24 24'
  };

  const renderIcon = () => {
    switch (icon) {
      case 'sky':
        return (
          <svg {...iconProps}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
            <path d="M12 6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
          </svg>
        );

      case 'pomegranate':
        return (
          <svg {...iconProps}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
            <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"/>
            <circle cx="9" cy="9" r="1"/>
            <circle cx="15" cy="9" r="1"/>
            <circle cx="9" cy="15" r="1"/>
            <circle cx="15" cy="15" r="1"/>
          </svg>
        );

      case 'song':
        return (
          <svg {...iconProps}>
            <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
          </svg>
        );

      case 'apple':
        return (
          <svg {...iconProps}>
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
          </svg>
        );

      case 'book':
        return (
          <svg {...iconProps}>
            <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
          </svg>
        );

      case 'cat':
        return (
          <svg {...iconProps}>
            <path d="M12 8l-3 4h6l-3-4z"/>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        );

      case 'sun':
        return (
          <svg {...iconProps}>
            <polygon fill="#ff9800" points="37,29 42,24 37,19 37,11 29,11 24,6 19,11 11,11 11,19 6,24 11,29 11,37 19,37 24,42 29,37 37,37"></polygon>
            <path fill="#ffeb3b" d="M13,24c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11s-4.9-11-11-11C17.9,13,13,17.9,13,24"></path>
          </svg>
        );

      case 'moon':
        return (
          <svg {...iconProps}>
            <path d="M12 3c.46 0 .93.04 1.4.14-2.04 1.05-3.4 3.1-3.4 5.36 0 3.31 2.69 6 6 6 2.26 0 4.31-1.36 5.36-3.4.1.47.14.94.14 1.4 0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2z"/>
          </svg>
        );

      case 'star':
        return (
          <svg {...iconProps}>
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        );

      case 'heart':
        return (
          <svg {...iconProps}>
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
          </svg>
        );

      case 'tree':
        return (
          <svg {...iconProps}>
            <path d="M12 2L4 9v12h16V9l-8-7zm0 2.5L18 10v9H6v-9l6-5.5z"/>
            <path d="M12 6l-3 3v8h6V9l-3-3z"/>
          </svg>
        );

      case 'water':
        return (
          <svg {...iconProps}>
            <path d="M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8z"/>
            <path d="M12 6c-2.67 2.27-4 4.24-4 5.8 0 2.49 1.9 4.1 4 4.1s4-1.61 4-4.1c0-1.56-1.33-3.53-4-5.8z"/>
          </svg>
        );

      case 'fire':
        return (
          <svg {...iconProps}>
            <path d="M12 2c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2s2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
            <path d="M12 8c-2.21 0-4 1.79-4 4v2c0 2.21 1.79 4 4 4s4-1.79 4-4v-2c0-2.21-1.79-4-4-4z"/>
            <path d="M12 16c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2s2-.9 2-2v-2c0-1.1-.9-2-2-2z"/>
          </svg>
        );

      case 'house':
        return (
          <svg {...iconProps}>
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
          </svg>
        );

      case 'door':
        return (
          <svg {...iconProps}>
            <path d="M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zM9 19V7h10v12H9z"/>
            <path d="M11 9h2v2h-2z"/>
          </svg>
        );

      case 'hand':
        return (
          <svg {...iconProps}>
            <path d="M18.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C23.34 15.67 24 13.91 24 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4v5l4-4v-7.73L19.73 21 21 19.73 4.27 3zM12 4L9 7H3v6h6l3-3V4z"/>
          </svg>
        );

      case 'friend':
        return (
          <svg {...iconProps}>
            <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H17c-.8 0-1.54.37-2.01 1l-1.99 2.5V18h-2v-8.5L9.01 9A2.5 2.5 0 0 0 7 8H5.46c-.8 0-1.54.37-2.01 1L.96 16.37A1.5 1.5 0 0 0 2.5 18H5v6h2v-6h3v6h2v-6h3v6h2z"/>
          </svg>
        );

      case 'sleep':
        return (
          <svg {...iconProps}>
            <path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"/>
            <path d="M9 11h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9z"/>
          </svg>
        );

      case 'good':
        return (
          <svg {...iconProps}>
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
          </svg>
        );

      case 'bird':
        return (
          <svg {...iconProps}>
            <path d="M23 4c-6.67-1-12.5-3.75-13.96-7.26-.64-.13-1.31.37-1.31 1.01 0 .45.3.87.74.98C10.88-1.29 15.71.52 20 4v2l-3.5 3.5L20 13v2l-3.5 3.5L20 22v2c-6.67-1-12.5-3.75-13.96-7.26-.64-.13-1.31.37-1.31 1.01 0 .45.3.87.74.98C10.88 18.71 15.71 20.52 20 24v-2l-3.5-3.5L20 15v-2l-3.5-3.5L20 6V4z"/>
          </svg>
        );

      case 'puzzle':
        return (
          <svg {...iconProps}>
            <path d="M4 4h6v6H4V4zm0 10h6v6H4v-6zm10-10h6v6h-6V4zm0 10h6v6h-6v-6z"/>
          </svg>
        );

      case 'money':
        return (
          <svg {...iconProps}>
            <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
          </svg>
        );

      case 'father':
        return (
          <svg width={size} height={size * 0.5} xmlns="http://www.w3.org/2000/svg">
            <text x="10" y={size * 0.35} font-family="Verdana" font-size={size * 0.3} fill="black">Father</text>
          </svg>
        );

      case 'snow':
        return (
          <svg {...iconProps}>
            <path d="M22 11h-4.17l3.24-3.24-1.41-1.41L15 11h-2V9l4.66-4.66-1.41-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.41L9 13h2v2l-4.66 4.66 1.41 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.41-1.41L13 15v-2h2l4.66 4.66 1.41-1.41L17.83 13H22z"/>
          </svg>
        );

      case 'leaf':
        return (
          <svg {...iconProps}>
            <path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1-2.3A5.17 5.17 0 0 0 8 20C19 20 22 3 22 3S21 5 17 8z"/>
          </svg>
        );

      case 'wind':
        return (
          <svg {...iconProps}>
            <path d="M14 5c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zM14 19c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zM2 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM20 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z"/>
          </svg>
        );

      case 'roof':
        return (
          <svg {...iconProps}>
            <path d="M12 3L4 9v12h16V9l-8-6z"/>
          </svg>
        );

      case 'nature':
        return (
          <svg {...iconProps}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        );

      case 'peacock':
        return (
          <svg {...iconProps}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
            <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"/>
            <circle cx="9" cy="9" r="1"/>
            <circle cx="15" cy="9" r="1"/>
            <circle cx="9" cy="15" r="1"/>
            <circle cx="15" cy="15" r="1"/>
          </svg>
        );

      case 'crown':
        return (
          <svg {...iconProps}>
            <path d="M12 8l3 4h2l-4-5-4 5h2l3-4z"/>
            <path d="M2 9h2v10H2z"/>
            <path d="M20 9h2v10h-2z"/>
            <path d="M6 9h2v10H6z"/>
            <path d="M16 9h2v10h-2z"/>
            <path d="M10 9h4v10h-4z"/>
          </svg>
        );

      case 'storm':
        return (
          <svg {...iconProps}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        );

      case 'green':
        return (
          <svg {...iconProps}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        );

      case 'morning':
        return (
          <svg {...iconProps}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
            <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"/>
          </svg>
        );

      case 'stone':
        return (
          <svg {...iconProps}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
          </svg>
        );

      case 'forest':
        return (
          <svg {...iconProps}>
            <path d="M12 2L4 9v12h16V9l-8-7zm0 2.5L18 10v9H6v-9l6-5.5z"/>
            <path d="M12 6l-3 3v8h6V9l-3-3z"/>
          </svg>
        );

      case 'cup':
        return (
          <svg {...iconProps}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
            <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"/>
  </svg>
);

      case 'road':
        return (
          <svg {...iconProps}>
            <path d="M12 2L4 9v12h16V9l-8-7z"/>
          </svg>
        );

      case 'war':
        return (
          <svg {...iconProps}>
            <path d="M12 2L4 9v12h16V9l-8-7z"/>
            <path d="M12 6l-3 3v8h6V9l-3-3z"/>
  </svg>
);

      default:
        return (
          <svg {...iconProps}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
            <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"/>
          </svg>
        );
    }
  };

  return renderIcon();
};

export default GridAlphabetIcon; 